/* eslint-disable */
let ConvId

const TwitterPixel = {
  init: convId => {
    ConvId = convId
    !(function (e, t, n, s, u, a) {
      e.twq ||
        ((s = e.twq =
          function () {
            s.exe ? s.exe.apply(s, arguments) : s.queue.push(arguments)
          }),
        (s.version = '1.1'),
        (s.queue = []),
        (u = t.createElement(n)),
        (u.async = !0),
        (u.src = '//static.ads-twitter.com/uwt.js'),
        (a = t.getElementsByTagName(n)[0]),
        a.parentNode.insertBefore(u, a))
    })(window, document, 'script')
    if (!ConvId) {
      return console.error('TwitterPixel.init(convId) missing conversion id.')
    } else {
      twq('init', ConvId)
    }
  },

  pageView: () => {
    if (!ConvId) {
      return console.error('TwitterPixel init must be called first.')
    }
    twq('track', 'PageView')
  },

  event: (name: string, data?: Record<string, unknown>) => {
    if (!ConvId) {
      return console.error('TwitterPixel init must be called first.')
    }
    twq('track', name, data)
  },
}

export default TwitterPixel
